﻿import React, { useEffect, useState } from "react";
import { ContextProvider } from "../Components";
import MaterialTable from "material-table";

export interface IDataFeedStatusDetailProps {
    uniqueName: string;
}

export const DataFeedStatusDetail: React.FunctionComponent<
    IDataFeedStatusDetailProps
> = (props: IDataFeedStatusDetailProps): React.ReactElement => {
    const [detailFeed, setDetailFeed] = useState([]);

    useEffect(() => {
        void getDataDetail(props);
    }, [props]);

    const getDataDetail = async (
        data: IDataFeedStatusDetailProps,
    ): Promise<void> => {
        const stringResult: string = await $.ajax(
            `/DataFeedStatus/GetDataFeedDetail`,
            {
                data,
                method: `GET`,
            },
        );

        const result: [] = JSON.parse(stringResult);

        setDetailFeed(result);
    };

    return (
        <ContextProvider>
            <div
                className={`scroll-style`}
                style={{
                    width: `100%`,
                    minWidth: `700px`,
                    padding: `5px`,
                    borderRadius: `5px`,
                }}
            >
                <MaterialTable
                    columns={[
                        {
                            field: `date`,
                            title: `Time Loaded `,
                            cellStyle: { padding: `5px` },
                        },
                        {
                            field: `status`,
                            title: `Status`,
                            cellStyle: { padding: `5px` },
                            // TODO: remove the eeslint disable and fix
                            // eslint-disable-next-line react/display-name
                            render: (rowData): React.ReactElement => (
                                <p>
                                    {rowData.status === 0
                                        ? `File Unsuccessful`
                                        : rowData.status === 1
                                          ? `File Loaded`
                                          : `Identified Issue`}
                                </p>
                            ),
                        },
                        {
                            field: `file_Name`,
                            title: `Additional Info`,
                            cellStyle: { padding: `5px` },
                        },
                    ]}
                    data={detailFeed}
                    options={{
                        search: false,
                        showTitle: false,
                        draggable: false,
                        paging: false,
                        toolbar: false,
                        minBodyHeight: "55vh",
                        maxBodyHeight: "10vh",
                        overflowY: "initial",
                        headerStyle: {
                            backgroundColor: `#395364`,
                            padding: `5px`,
                            borderTop: `0px`,
                        },
                    }}
                    style={{ padding: `8px` }}
                />
            </div>
        </ContextProvider>
    );
};
